import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, MessagePlugin } from 'tdesign-react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchComponentVariables } from '@/slices/execComponentSlice';
import Panel from '@/components/Panel';
import { runComponent } from '@/services/execComponentService';
import { validateAll } from '@/pages/Maintenance/Executive/components/Variables';
import { OPERATE } from '..';
import Main from './Main';
import SelectHost from './SelectHost';
import Summary from './Summary';

function Config({
  operate,
  currentHosts,
  currentEnv,
  currentCluster,
  fetchComponentVariables,
  currentLib,
  currentVariables,
  currentIpVariables,
}) {
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const id = searchParams.get('id');

  const title = useMemo(() => {
    if (operate === OPERATE.DEPLOY) {
      return '基本信息-新部署';
    }
    if (operate === OPERATE.UPGRADE) {
      return '基本信息-升级';
    }
  }, [operate]);

  useEffect(() => {
    if (isEmpty(currentHosts)) {
      return;
    }
    fetchComponentVariables({
      componentStencilId: id,
      envId: currentEnv.id,
      clusterId: currentCluster.id,
      hostsList: currentHosts.map((item) => item.id).join(','),
    });
  }, [currentHosts, id, currentEnv, currentCluster, fetchComponentVariables]);

  const doSubmit = async () => {
    if (isEmpty(currentHosts)) {
      MessagePlugin.warning('请选择要执行的主机');
      return;
    }
    if (!validateAll(currentVariables, currentIpVariables)) {
      return;
    }

    const params = {
      clusterId: currentCluster.id,
      componentStencilId: id,
      envId: currentEnv.id,
      hostsList: currentHosts.map((host) => host.id).join(','),
      // 默认变量合并
      ipVariableList: currentIpVariables.map((item) => ({
        currenValue: item.defaultValue,
        ip: item.host.id,
        key: item.key,
        scriptStencilVariableId: item.scriptStencilVariableId,
      })),
      variableList: currentVariables.map((item) => ({
        currenValue: item.defaultValue,
        key: item.key,
        scriptStencilVariableId: item.scriptStencilVariableId,
        stencilId: id,
      })),
      scriptBusinessEnum: 'DEPLOY', // 暂固定，需确认升级是否也用Deploy
      // scriptBusinessEnum: operate,
      versionId: currentLib.id,
    };

    try {
      setSubmitting(true);
      const {
        data: { id, clusterId },
      } = await runComponent(params);
      MessagePlugin.success('执行成功');
      navigate(`/maintenance/executive/record/detail?id=${id}&clusterId=${clusterId}`);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Root>
      <Container>
        <Summary title={title} />
        <SelectHost />
        {!isEmpty(currentHosts) && <Main />}
      </Container>
      {!isEmpty(currentHosts) && (
        <Footer>
          <Button theme='primary' loading={submitting} onClick={doSubmit}>
            开始执行
          </Button>
        </Footer>
      )}
    </Root>
  );
}

export default connect(
  (state) => ({
    currentHosts: state.execComponent.currentHosts,
    currentLib: state.execComponent.currentLib,
    currentIpVariables: state.execComponent.currentIpVariables,
    currentVariables: state.execComponent.currentVariables,
    currentEnv: state.execComponent.currentEnv,
    currentCluster: state.execComponent.currentCluster,
    operate: state.execComponent.operate,
  }),
  {
    fetchComponentVariables,
  },
)(Config);

const Root = styled(Panel)`
  margin-right: 20px;
  .shadow-card-body {
    padding: 0;
  }
`;

const Container = styled.div`
  padding: 20px;
`;

const Footer = styled.div`
  border-top: 1px solid #e7e7e7;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24px;
`;
